import React, { useRef } from "react";
import "./css/Feature1.css";

export default function Feature1() {
  const heartRef = useRef(null);
  const FADE_DURATION = 1000; // ms

  const onHeartActivate = () => {
    const btn = heartRef.current;
    if (!btn) return;

    btn.classList.toggle("liked");
    const isLiked = btn.classList.contains("liked");
    if (!isLiked) return;

    const particles = [];
    for (let i = 0; i < 5; i += 1) {
      const particle = document.createElement("span");
      particle.classList.add("particle");

      const angle = random(0, 360);
      const distance = random(26, 38);
      particle.style.setProperty("--angle", `${angle}deg`);
      particle.style.setProperty("--distance", `${distance}px`);
      particle.style.setProperty("--fade-duration", `${FADE_DURATION}ms`);

      btn.appendChild(particle);
      particles.push(particle);
    }

    window.setTimeout(() => {
      particles.forEach((p) => p.remove());
    }, FADE_DURATION + 200);
  };

  const onHeartKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onHeartActivate();
    }
  };

  return (
    <section className="feature1">
      <h2>Feature 1</h2>
      <p className="subtitle">Click the heart to trigger the particle burst.</p>

      {/* Centered stage */}
      <div className="heart-stage">
        {/* Clipping box in the middle */}
        <div className="showcase-box">
          {/* Local wrapper that centers and constrains the heart */}
          <div className="heart-wrap">
            <button
              type="button"
              className="particleButton"
              ref={heartRef}
              onClick={onHeartActivate}
              onKeyDown={onHeartKeyDown}
              aria-pressed="false"
              aria-label="Like"
              title="Like"
            >
              {/* Empty outline before click; solid red after (CSS) */}
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M3.68546 5.43796C8.61936 1.29159 11.8685 7.4309 12.0406 7.4309C12.2126 7.43091 15.4617 1.29159 20.3956 5.43796C26.8941 10.8991 13.5 21.8215 12.0406 21.8215C10.5811 21.8215 -2.81297 10.8991 3.68546 5.43796Z"
                  stroke="#ff426a"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              <span className="visually-hidden">Like</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* helpers */
function random(lower = 0, upper = 1, floating) {
  if (upper === undefined) {
    upper = lower;
    lower = 0;
  }
  if (
    floating === true ||
    !Number.isInteger(lower) ||
    !Number.isInteger(upper)
  ) {
    return Math.random() * (upper - lower) + lower;
  }
  return Math.floor(Math.random() * (upper - lower + 1)) + lower;
}
